/**
*
* Asynchronously loads the component for ExceededRequest
*
*/
import React from 'react';
import { lazyLoad } from 'common/loadable';
import { PageLoading } from 'app/components/common/pageLoading';

export const ExceededRequest = lazyLoad(() => import('./index'), module => module.ExceededRequest, {fallback: <PageLoading />,},);